<template>
    <div class="main">

        <!-- LISTAGEM -->
        <c-panel>
            <el-form label-position="top">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="24">
                        <el-form-item label="Instituição" key="instituicao">
                            <el-select v-if="ehSmed" size="small" v-model="filtro.instituicao_id" @change="onChangeInstituicao" filterable clearable placeholder="- TODAS AS INSTITUIÇÕES -" style="width: 100%;">
                                <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"></el-option>
                            </el-select>
                            <div v-else class="style-input readonly">{{ $store.state.config.instituicao.nome }}</div>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="6" :md="6">
                        <el-form-item label="Turma" key="turma">
                            <el-select size="small" v-model="filtro.turma_id" @change="carregar(1)" filterable clearable placeholder="Todas" style="width: 100%;">
                                <el-option-group v-for="(grupo, i) in turmas" :key="i" :label="i">
                                    <el-option v-for="t in grupo" :key="t.id" :label="`${t.curso.nome} ${t.nome}`" :value="t.id"></el-option>
                                </el-option-group>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6" :md="6">
                        <el-form-item label="Tipo de Ocorrência" key="tipo">
                            <el-select size="small" v-model="filtro.tipo_ocorrencia_id" @change="carregar(1)" filterable clearable placeholder="Todos" style="width: 100%;">
                                <el-option v-for="t in tipos" :key="t.id" :label="t.nome" :value="t.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12">
                        <el-form-item label="Aluno" key="aluno">
                            <el-select size="small" v-model="filtro.aluno_id" @change="carregar(1)" filterable remote clearable :remote-method="buscarAlunos" :loading="loadingAlunos" placeholder="Pesquisar aluno" style="width: 100%;">
                                <el-option v-for="a in alunosBusca" :key="a.id" :label="a.nome" :value="a.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="10" :md="10">
                        <el-form-item label="Período (data)" key="periodo">
                            <el-date-picker size="small" v-model="filtro.periodo" @change="carregar(1)" type="daterange" value-format="yyyy-MM-dd" format="dd/MM/yyyy" range-separator="até" start-placeholder="Início" end-placeholder="Fim" style="width: 100%;"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="14" :md="14" class="u-text-right">
                        <el-button size="small" style="margin-top: 18px;" type="primary" plain @click="imprimir()">
                            <i class="el-icon-printer u-mr-5"></i>
                            IMPRIMIR
                        </el-button>
                        <el-button size="small" style="margin-top: 18px;" type="primary" plain @click="abrirModal()">
                            <i class="fas fa-plus u-mr-5"></i>
                            NOVA OCORRÊNCIA
                        </el-button>
                    </el-col>
                </el-row>
            </el-form>
            <div class="container-table">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th style="width: 100px;">Data</th>
                            <th>Aluno</th>
                            <th class="hidden-mobile">Curso / Turma</th>
                            <th class="hidden-mobile">Tipo</th>
                            <th class="hidden-mobile">Registrado por</th>
                            <th style="width: 120px;" class="u-text-center">Ação</th>
                        </tr>
                    </thead>
                    <tbody v-if="statusList">
                        <tr v-for="item in items" :key="item.id">
                            <td>{{ formatarData(item.data) }}</td>
                            <td class="u-uppercase">
                                <a v-if="item.aluno" @click="openDossie(item.aluno)" title="Abrir dossiê do aluno" href="javascript:void(0)">{{ item.aluno.nome }}</a>
                                <span v-else>-</span>
                            </td>
                            <td class="hidden-mobile u-uppercase">{{ item.turma && item.turma.curso ? (item.turma.curso.nome + ' / ' + item.turma.nome) : '-' }}</td>
                            <td class="hidden-mobile u-uppercase">{{ item.tipo_ocorrencia ? item.tipo_ocorrencia.nome : '-' }}</td>
                            <td class="hidden-mobile">{{ item.usuario ? item.usuario.name : '-' }}</td>
                            <td class="u-text-center acao">
                                <el-button type="info" title="Editar" icon="el-icon-edit" size="mini" plain :disabled="!podeEditar(item)" @click="abrirModal(item)"></el-button>
                                <el-button style="margin-left: 8px;" type="danger" title="Excluir" icon="el-icon-delete" size="mini" plain :disabled="!podeEditar(item)" @click="excluir(item)"></el-button>
                            </td>
                        </tr>
                        <tr v-if="!items.length">
                            <td colspan="7" class="u-text-center" style="padding: 20px; color: #909399;">Nenhuma ocorrência encontrada.</td>
                        </tr>
                    </tbody>
                </table>
                <div v-if="!statusList" class="u-text-center u-mt-25"><img src="/public/img/loading-bar.gif" /></div>

                <el-row :gutter="10" v-if="statusList">
                    <el-col :xs="24" :sm="12"><div class="u-text-left u-mt-10">Mostrando {{ paginate.from }} até {{ paginate.to }} de {{ paginate.qtdItens }} registros.</div></el-col>
                    <el-col :xs="24" :sm="12" v-if="paginate.qtdItens > 15">
                        <div class="u-text-right">
                            <el-pagination :current-page="paginate.page" class="u-mt-10" :total="paginate.qtdItens" @current-change="carregar" :page-size="15" background layout="prev, pager, next" small></el-pagination>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </c-panel>

        <!-- MODAL -->
        <el-dialog :title="dados.id ? 'EDITAR OCORRÊNCIA' : 'NOVA OCORRÊNCIA'" :visible.sync="modalVisivel" width="60%" :close-on-click-modal="false" append-to-body>
            <el-form label-position="top" :model="dados" ref="form" @submit.native.prevent>
                <el-row :gutter="10" class="u-mt-20">
                    <el-col :xs="24" :sm="16">
                        <el-form-item label="Aluno" prop="aluno_id" :rules="[$requiredChange]">
                            <el-select v-model="dados.aluno_id" filterable remote clearable :remote-method="buscarAlunosModal" :loading="loadingAlunosModal" placeholder="Pesquisar aluno" style="width: 100%;">
                                <el-option v-for="a in alunosBuscaModal" :key="a.id" :label="a.nome" :value="a.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Data" prop="data" :rules="[$requiredChange]">
                            <el-date-picker v-model="dados.data" type="date" value-format="yyyy-MM-dd" format="dd/MM/yyyy" placeholder="Data" style="width: 100%;"></el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24">
                        <el-form-item label="Tipo de Ocorrência" prop="tipo_ocorrencia_id" :rules="[$requiredChange]">
                            <el-select v-model="dados.tipo_ocorrencia_id" filterable placeholder="Selecione" style="width: 100%;">
                                <el-option v-for="t in tipos" :key="t.id" :label="t.nome" :value="t.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24">
                        <el-form-item label="Descrição" prop="descricao">
                            <el-input type="textarea" :rows="4" v-model="dados.descricao" maxlength="1000" show-word-limit></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer">
                <el-button @click="modalVisivel = false">CANCELAR</el-button>
                <el-button class="u-ml-10" type="primary" :loading="salvando" @click="salvar">SALVAR</el-button>
            </div>
        </el-dialog>

        <!-- DOSSIÊ DO ALUNO -->
        <el-dialog :close-on-click-modal="false" title="DOSSIÊ DO ALUNO" width="90%" top="40px" :visible.sync="dialogDossieAluno" v-on:close="alunoSelected = {}">
            <div v-if="dialogDossieAluno" style="margin-top: 20px;">
                <dossie-aluno :id="alunoSelected.id" v-on:changeDossie="changeDossie"></dossie-aluno>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import dossieAluno from '@/components/aluno/dossie'

export default {
    components: { dossieAluno },
    data () {
        return {
            statusList: false,
            salvando: false,
            loadingAlunos: false,
            loadingAlunosModal: false,
            filtro: { instituicao_id: '', turma_id: '', tipo_ocorrencia_id: '', aluno_id: '', periodo: [] },
            paginate: { page: 1, qtdItens: null, from: '', to: '' },
            items: [],
            turmas: [],
            tipos: [],
            alunosBusca: [],
            alunosBuscaModal: [],
            modalVisivel: false,
            dialogDossieAluno: false,
            alunoSelected: {},
            dados: { id: '', aluno_id: '', data: '', tipo_ocorrencia_id: '', descricao: '' }
        }
    },
    computed: {
        ehSmed () { return [4, 5, 6, 7, 8, 10].includes(Number(this.$store.state.user.tipo)) },
        periodoLetivoId () { return this.$store.state.config.parametros.periodo_letivo_situacao_academica }
    },
    mounted () {
        if (!this.ehSmed) { this.filtro.instituicao_id = this.$store.state.config.instituicao.id }
        this.carregarTipos()
        this.carregarTurmas()
        this.carregar(1)
    },
    methods: {
        carregarTipos () {
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/ocorrencia/getTiposOcorrencia`, this.$store.getters.getHeaderAuth)
                .then(r => { this.tipos = Array.isArray(r.data) ? r.data : [] })
                .catch(e => this.$store.commit('throwException', e))
        },
        carregarTurmas () {
            this.turmas = []
            if (!this.filtro.instituicao_id || !this.periodoLetivoId) return
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/turma/getTurmasForListDiario/${this.filtro.instituicao_id}/${this.periodoLetivoId}`, this.$store.getters.getHeaderAuth)
                .then(r => { this.turmas = r.data })
                .catch(e => this.$store.commit('throwException', e))
        },
        onChangeInstituicao () {
            this.filtro.turma_id = ''
            this.carregarTurmas()
        },
        buscarAlunos (query) {
            if (!query || query.length < 3) { this.alunosBusca = []; return }
            this.loadingAlunos = true
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/ocorrencia/searchAlunos`, { query }, this.$store.getters.getHeaderAuth)
                .then(r => { this.alunosBusca = Array.isArray(r.data) ? r.data : []; this.loadingAlunos = false })
                .catch(e => { this.loadingAlunos = false; this.$store.commit('throwException', e) })
        },
        buscarAlunosModal (query) {
            if (!query || query.length < 3) { this.alunosBuscaModal = []; return }
            this.loadingAlunosModal = true
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/ocorrencia/searchAlunos`, { query }, this.$store.getters.getHeaderAuth)
                .then(r => { this.alunosBuscaModal = Array.isArray(r.data) ? r.data : []; this.loadingAlunosModal = false })
                .catch(e => { this.loadingAlunosModal = false; this.$store.commit('throwException', e) })
        },
        imprimir () {
            window.eventBus.$emit('print', {
                url: '/api/ocorrencia/imprimir',
                param: {
                    instituicao_id: this.filtro.instituicao_id || '',
                    turma_id: this.filtro.turma_id || '',
                    tipo_ocorrencia_id: this.filtro.tipo_ocorrencia_id || '',
                    aluno_id: this.filtro.aluno_id || '',
                    data_inicio: (this.filtro.periodo && this.filtro.periodo[0]) || '',
                    data_fim: (this.filtro.periodo && this.filtro.periodo[1]) || '',
                    periodo_letivo_id: this.periodoLetivoId
                }
            })
        },
        carregar (page) {
            this.paginate.page = page || 1
            this.statusList = false
            this.items = []
            const payload = {
                instituicao_id: this.filtro.instituicao_id || '',
                turma_id: this.filtro.turma_id || '',
                tipo_ocorrencia_id: this.filtro.tipo_ocorrencia_id || '',
                aluno_id: this.filtro.aluno_id || '',
                data_inicio: (this.filtro.periodo && this.filtro.periodo[0]) || '',
                data_fim: (this.filtro.periodo && this.filtro.periodo[1]) || '',
                periodo_letivo_id: this.periodoLetivoId
            }
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/ocorrencia/getByFiltrosPaginate?page=${this.paginate.page}`, payload, this.$store.getters.getHeaderAuth)
                .then(r => {
                    this.items = r.data.data
                    this.paginate.qtdItens = r.data.total
                    this.paginate.from = r.data.from
                    this.paginate.to = r.data.to
                    this.statusList = true
                }).catch(e => { this.statusList = true; this.$store.commit('throwException', e) })
        },
        abrirModal (item) {
            this.alunosBuscaModal = []
            if (item) {
                this.dados = { id: item.id, aluno_id: item.aluno_id, data: item.data, tipo_ocorrencia_id: item.tipo_ocorrencia_id, descricao: item.descricao || '' }
                if (item.aluno) this.alunosBuscaModal = [{ id: item.aluno.id, nome: item.aluno.nome }]
            } else {
                this.dados = { id: '', aluno_id: '', data: this.$moment().format('YYYY-MM-DD'), tipo_ocorrencia_id: '', descricao: '' }
            }
            this.modalVisivel = true
            this.$nextTick(() => { if (this.$refs.form) this.$refs.form.clearValidate() })
        },
        salvar () {
            this.$refs.form.validate(valid => {
                if (!valid) { window.eventBus.$emit('alert', { msg: 'Preencha os campos obrigatórios.', type: 'warning' }); return }
                this.salvando = true
                const payload = {
                    aluno_id: this.dados.aluno_id,
                    data: this.dados.data,
                    tipo_ocorrencia_id: this.dados.tipo_ocorrencia_id,
                    descricao: this.dados.descricao,
                    instituicao_id: this.filtro.instituicao_id || this.$store.state.config.instituicao.id,
                    periodo_letivo_id: this.periodoLetivoId
                }
                const url = this.dados.id
                    ? `${this.$store.state.config.baseUrlApi}/api/ocorrencia/update/${this.dados.id}`
                    : `${this.$store.state.config.baseUrlApi}/api/ocorrencia/store`
                this.$axios.post(url, payload, this.$store.getters.getHeaderAuth).then(r => {
                    this.salvando = false
                    if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: r.data.erro, type: 'warning' }); return }
                    window.eventBus.$emit('alert', { msg: 'Ocorrência salva com sucesso.', type: 'success' })
                    this.modalVisivel = false
                    this.carregar(this.paginate.page)
                }).catch(e => { this.salvando = false; this.$store.commit('throwException', e) })
            })
        },
        excluir (item) {
            this.$msgbox.confirm('Tem certeza que deseja excluir esta ocorrência?', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }).then(() => {
                window.eventBus.$emit('loading', true)
                this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/ocorrencia/delete/${item.id}`, this.$store.getters.getHeaderAuth).then(r => {
                    window.eventBus.$emit('loading', false)
                    if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: r.data.erro, type: 'warning' }); return }
                    window.eventBus.$emit('alert', { msg: 'Ocorrência excluída com sucesso.', type: 'success' })
                    this.carregar(this.paginate.page)
                }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
            }).catch(() => {})
        },
        openDossie (aluno) {
            this.alunoSelected = { id: aluno.id }
            this.dialogDossieAluno = true
        },
        changeDossie (actions) {
            if (actions && actions.close) this.dialogDossieAluno = false
        },
        podeEditar (item) {
            const tipo = Number(this.$store.state.user.tipo)
            if ([4, 5, 6, 7, 8].includes(tipo)) return true
            return item.user_id === this.$store.state.user.id
        },
        formatarData (d) {
            return d ? this.$moment(d).format('DD/MM/YYYY') : '-'
        }
    }
}
</script>
